<template>
  <div id="grid">
    <div class="tags">
      <div class="tag-container" v-for="tag in theTags" :key="tag.id + '_p'">
        <button
          class="tag"
          :class="{ active: clickedTags.indexOf(tag.id) != -1 }"
          @click="pushTags($event, tag.id)"
        >
          {{ tag.name }}
        </button>
      </div>
    </div>
    <transition name="slide-fade">
      <StartPageTexts v-if="(clickedTags.length < 1)"/>
    </transition>
    <!-- Man kan nog flytta in den här logiken i en computed -->
    <transition name="slide-fade">
      <div class="latest-post-container">
        <div class="latest-posts">
            <a @click="setArticle(post)" v-for="(post, index) in filteredArticles" v-bind:key="post.id  + '_b'" name="latest-posts-item" class="animated fadeInUp" v-if="page !== 0 || index < 4">
              <img v-bind:src="post.acf.image.sizes.medium_large">
              <p class="playfair-normal" v-html="post.title.rendered"></p>
              <p v-html="post.excerpt.rendered"></p>
              <button class="tag">Läs mer</button>
            </a>
        </div>
      </div>
    </transition>
    <!--<transition name="slide-fade">
      <div class="latest-post-container">
        <div v-if="((clickedTags.length < 1) && (search === ''))" class="latest-posts">
            <a @click="setArticle(post)" v-for="(post, index) in article" v-bind:key="post.id  + '_b'" name="latest-posts-item" class="animated fadeInUp" v-if="page !== 0 || index < 4">
              <img v-bind:src="post.acf.image.url">
              <p class="playfair-normal" v-html="post.title.rendered"></p>
              <p v-html="post.excerpt.rendered"></p>
              <button class="tag">Läs mer</button>
            </a>
        </div>
        <div v-if="((clickedTags.length >= 1) && (search === ''))" class="latest-posts">
            <a @click="setArticle(post)" v-for="(post, index) in filteredPosts" v-bind:key="post.id  + '_d'" class="animated fadeInUp" name="latest-posts-item" v-if="page !== 0 || index < 4">
              <img v-bind:src="post.acf.image.url">
              <p class="playfair-normal" v-html="post.title.rendered"></p>
              <p v-html="post.excerpt.rendered"></p>
              <button class="tag">Läs mer</button>
            </a>
        </div>
        <div v-if="search !== ''" class="latest-posts">
            <a @click="setArticle(post)" v-for="(post, index) in searchResult" v-bind:key="post.id  + '_c'" name="latest-posts-item" class="animated fadeInUp" v-if="page !== 0 || index < 4">
              <img v-bind:src="post.acf.image.url">
              <p class="playfair-normal" v-html="post.title.rendered"></p>
              <p v-html="post.excerpt.rendered"></p>
                <button class="tag">Läs mer</button>
            </a>
        </div>
      </div>
    </transition>-->
    <div v-if="page === 0" class="see-more-button playfair-normal" @click="page++">
      Fler artiklar
    </div>
  </div>
</template>

<script>
import StartPageTexts from '@/components/StartPageTexts'
import CustomButton from './CustomButton'

export default {
  name: 'Grid',
  data () {
    return {
      filteredPosts: [],
      searchResult: [],
      page: 0
    }
  },
  props: [],
  beforeMount () {
  },
  methods: {
    matchArticleTags (article, clickedTags) {
      let result = article.tags.filter((tag) => {
        let found = false
        clickedTags.forEach((clickedTag) => {
          if (clickedTag === tag) {
            found = true
          }
        })
        return found
      })
      if (result.length > 0) {
        return true
      }
      return false
    },
    pushTags (event, id) {
      var found = this.clickedTags.indexOf(id) > -1
      if (found) {
        this.$store.commit('removeClickedTag', id)
      } else {
        this.$store.commit('setCurrentTag', id)
      }
    },
    filterPosts () {
      var pushedTags = this.clickedTags
      var filteredArticles = []
      this.article.map(function (article) {
        article.tags.map(function (tag) {
          pushedTags.map(function (clickTag, i, arr) {
            if (clickTag === tag) {
              filteredArticles.push(article)
            }
          })
        })
      })
      this.filteredPosts = filteredArticles.filter((v, i) => filteredArticles.indexOf(v) === i)
    },
    setArticle (article) {
      this.$store.dispatch('getArticle', article)
      this.$router.push('/article/' + article.slug)
      return false
    }
  },
  computed: {
    filteredArticles () {
      let self = this
      if (this.search !== '') {
        return this.searchResult
      }
      return this.article.filter((article) => {
        //  if clicked tags
        if (self.clickedTags.length > 0) {
          return self.matchArticleTags(article, self.clickedTags)
        }
        return true
      })
    },
    pages () {
      return this.$store.state.pages
    },
    article () {
      return this.$store.state.posts
    },
    theTags () {
      return this.$store.state.tags
    },
    clickedTags () {
      return this.$store.state.currentTags
    },
    autoSuggestList () {
      var searchInput = this.search.toLowerCase()
      var matches = []
      this.article.map(function (article) {
        if (article.title.rendered.toLowerCase().match(searchInput) !== null) {
          matches.push(article)
        }
      })
      return matches
    },
    search () {
      return this.$store.state.search
    }
  },
  watch: {
    clickedTags () {
      this.filterPosts()
    },
    search () {
      if (this.search !== '') {
        /* Detta görs lättare genom att kolla om taggen finns i current tags (se oven)
        var tagDiv = document.getElementsByClassName('tags')
        var elementList = tagDiv[0].children
        var elementArray = Array.prototype.slice.call(elementList)
        elementArray.map(function (el) {
          el.className[0] = ''
        }) */
      }
      this.searchResult = this.autoSuggestList
      this.$store.dispatch('getSearchResult', this.autoSuggestList)
    }
  },
  components: { CustomButton, StartPageTexts }
}
</script>

<style lang="scss">
body {
  overflow-x: hidden;
}
button {
  cursor: pointer;
}
#grid .latest-posts {
  .playfair-normal {
    margin: 0 auto;
    width: 100%;
  }
  a[name=latest-posts-item] .text-container p {
    font-size: 16px;
    line-height: 20px;
    margin: 0 auto;
    text-align: center;
    width: 100%;
  }
}
@media #{$phones} {
}
</style>
<style lang="scss" scoped>
#grid {
  /*
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
  display: block;
  width: 100%;
  height: 100%;
  padding-top: 30px;
  .kort {
    color: black;
  }
  .tags {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 50px;
    margin-top: 20px;
    .tag-container {
      display: flex;
      flex-grow: 1;
      box-sizing: border-box;
      padding: 5px 5px;
    }
    &:after {
      content: '';
      flex-grow: 1000000000;
    }
    button {
      background: $lightGrey;
      border: none;
      height: 40px;
      width: 100%;
      box-sizing: border-box;
      color: $black;
      font-size: 15px;
      font-family: 'Playfair Display';
      font-weight: 700;
      transition: all 0.3s ease;
      padding: 0px 20px;
      &.active {
        background-color: $purple;
        color: white;
      }
      &:hover {
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.2);
        background-color: $darkGrey;
        color: white;
      }
    }
    .active:hover {
      background-color: $purple;
    }
  }
  .latest-post-container {
    margin: auto;
    padding-top: 10px;
    margin-left: -2.5%;
    margin-right: -2.5%;
  }
  .latest-posts {
    width: 100%;
    height: auto;
    min-height: 730px;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    margin-top: 20px;
    box-sizing: border-box;
    a[name=latest-posts-item] {
      width: 45%;
      display: block;
      box-sizing: border-box;
      margin: 0% 2.5% 5% 2.5%;
      border: 2px solid $lightGrey;
      height: 365px;
      position: relative;
      box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.05);
      transition: all 0.3s ease;
      cursor: pointer;
      .playfair-normal {
        font-size: 20px;
      }
      &:hover {
        box-shadow: 0px 0px 26px 0px rgba(0,0,0,0.19);
      }
      color: inherit;
      text-decoration: inherit;
      & > p {
        padding: 2px 10px;
        box-sizing: border-box;
      }
      padding-bottom: 50px;
    }
    .playfair-normal {
      margin-bottom: 8px;
    }
    img {
      width:100%;
      height: 50%;
      object-fit: cover;
      margin-bottom: 8px;
    }
    button {
      width:100%;
      min-height:50px;
      color: $purple;
      background-color: $lightGrey;
      border: none;
      position:absolute;
      bottom:0;
      right: 0;
      cursor: pointer; // sass
      transition: all 0.4s ease;
    }
    a:hover {
      button {
        color: $purple;
        background-color: $lightGrey;
      }
    }
  }
  .see-more-button {
    margin-top: 75px;
    margin-bottom: 15px;
    color: $purple;
    border-bottom: 3px solid $purple;
    padding-bottom: 5px;
    cursor: pointer;
    opacity: 0.9;
    display: inline-block;
    &:hover {
      opacity: 1;
    }
  }
}

@media screen and (max-width: 1800px) {
  #grid .latest-posts   abs(number)[name=latest-posts-item] {
  }
}
@media #{$ipads} {
  /*#grid .tags .tag-container {
    width: 33%;
  } */
  #grid .latest-posts {
    width: 100%;
  }
}
@media #{$small-pads} {
  #grid .latest-posts a[name=latest-posts-item] {
    width: 96%;
  }
  #grid .tags .tag-container {
    button {
      padding: 0px 10px;
    }
  }
  #grid .latest-posts {
    width: 100%;
  }
  #grid .latest-posts a[name=latest-posts-item]  {
    img {
      height: 33%;
      min-height: 125px;
    }
  }
}
@media #{$phones} {
  #grid .latest-posts a[name=latest-posts-item] {
    width: 95%;
    margin:0 auto;
    margin-top:10px;
    margin-bottom: 20px;
    max-height: 350px
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .4s ease;
}
.slide-fade-leave-active {
  transition: all .4s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(50px);
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Grid.vue